import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../../../core/repositories/usersMeRepository';
import {validateCookie} from '../../../../core/usecases/auth/checkOauthTokenExistence';
import {TopPage} from '../../../../features/skillCheck/engineer/component/TopPage';
import {withHandler} from '../../../../server/token/withHandler';
import {ScriptForGA} from '../../../../shared/components/ScriptForGA';
import {EngineerPageLayout} from '../../../../shared/components/layouts/EngineerPageLayout';
import type {NextPageWithLayout} from '../../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>(
  {auth: 'optional'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;
    const {isValid} = validateCookie(cookies);
    if (!isValid) {
      return {
        props: {},
      };
    }

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

const Page: NextPageWithLayout<Props> = ({userDataForAnalytics}: Props) => {
  return (
    <>
      <TopPage />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default Page;

Page.getLayout = (page) => (
  <EngineerPageLayout withSpBanner={false}>{page}</EngineerPageLayout>
);
